import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, COMPANY_DETAILS, PUBLIC } from "../../common/URLs";

export const fetchCompanyDetails = async (uuid) => {
  const url = `${BASE_URL}/${PUBLIC}/${COMPANY_DETAILS}/${uuid}`;
  try {
    const token = await fetchToken();
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching company details:", error);
    throw error; // Make sure to re-throw the error
  }
};